import { render, staticRenderFns } from "./SpecialPriceEdit_Details.vue?vue&type=template&id=7ef16b99&"
import script from "./SpecialPriceEdit_Details.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceEdit_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports